import React, { useState } from 'react'

import CallToActionButton from 'components/common/CallToActionButton/CallToActionButton'
import TextButton from 'components/common/TextButton/TextButton'
import { openModal, ModalContent } from 'redux/slices/globalModal'
import { useDispatch } from 'react-redux'
import useStyles from './styles'
import { useAuthenticatedState } from 'libs/web-client/utils/auth0/src'

const FullRecordingModal = props => {
    const classes = useStyles()
    const [showErrorMsg, setShowErrorMsg] = useState(false)
    const dispatch = useDispatch()
    const { isAuthenticated, user } = useAuthenticatedState()
    return (
        <div className={classes.root}>
            <h2 className={classes.title}>Missed this show?</h2>
            <p className={classes.subtitle}>
                Unfortunately our content can only be experienced live. Let us know if you want first access to the full
                video.
            </p>
            <CallToActionButton
                onClick={() => {
                    if (isAuthenticated) {
                        window.heap.track('User wants to see full recording', { userId: user.id })
                        props.closeModal()
                    } else {
                        setShowErrorMsg(true)
                    }
                }}
                type="primary"
                size="normal"
                display="block"
                text="REQUEST ACCESS"
            />
            {showErrorMsg && (
                <p className={classes.error}>
                    In order to request access you must have a user account. <br /> Sign up or sign in{' '}
                    <TextButton
                        onClick={() =>
                            dispatch(
                                openModal({
                                    content: ModalContent.SIGNUP,
                                }),
                            )
                        }
                        text="here"
                    />
                </p>
            )}
        </div>
    )
}

export default React.memo(FullRecordingModal)
